const REGULAR_SEASON_IDS = [
  "cmp4yz2lj00017rtcc4ok0jgv", // regular season 1
  "cmrz0wo8t0000bpzcana86bow", // regular season 2
];

const REGULAR_SEASON_ID_SET = new Set(REGULAR_SEASON_IDS);

function isRegularSeasonId(seasonId) {
  return REGULAR_SEASON_ID_SET.has(seasonId);
}

function getDefaultRegularSeasonId() {
  return REGULAR_SEASON_IDS[1] || REGULAR_SEASON_IDS[0] || null;
}

export {
  REGULAR_SEASON_IDS,
  REGULAR_SEASON_ID_SET,
  isRegularSeasonId,
  getDefaultRegularSeasonId,
};
